export const shipmentHeaders = {
  containerNo: {
    name: "Container",
    width: 0.3,
  },
  location: {
    name: "Location",
    width: 0.2,
  },
  ETD: {
    name: "ETD",
    width: 0.25,
  },
  ETA: {
    name: "ETA",
    width: 0.25,
  },
  shippingLine: {
    name: "Shipping Line",
    width: 0.3,
  },
  sealNo: {
    name: "Seal No.",
    width: 0.3,
  },
  generatedBy: {
    name: "Created By",
    width: 0.25,
  },
  approvedBy: {
    name: "Approved By",
    width: 0.25,
  },
  createdAt: {
    name: "Created Date",
    width: 0.35,
  },
  shipmentActions: {
    name: "",
    width: 0.15,
    textAlign: "center",
  },
};

export const mdShipmentHeaders = {
  containerNo: {
    name: "Container",
    width: 0.4,
  },
  ETD: {
    name: "ETD",
    width: 0.25,
  },
  ETA: {
    name: "ETA",
    width: 0.25,
  },
  sealNo: {
    name: "Seal No.",
    width: 0.3,
  },
  createdAt: {
    name: "Created Date",
    width: 0.3,
  },
  shipmentActions: {
    name: "",
    width: 0.2,
    textAlign: "right",
  },
};

export const smShipmentHeaders = {
  containerNo: {
    name: "Container",
    width: 0.5,
  },
  ETD: {
    name: "ETD",
    width: 0.3,
  },
  ETA: {
    name: "ETA",
    width: 0.3,
  },
  shipmentActions: {
    name: "",
    width: 0.2,
    textAlign: "center",
  },
};

export const mdNestedShipmentHeaders = {
  orderNumber: {
    name: "Order No.",
    width: 0.3,
  },
  chinaItemCode: {
    name: "Item Code",
    width: 0.3,
  },
  qtyTotal: {
    name: "Qty",
    width: 0.25,
  },
  gwTotal: {
    name: "GW",
    width: 0.25,
  },
  nwTotal: {
    name: "NW",
    width: 0.25,
  },
};

export const smNestedShipmentHeaders = {
  chinaItemCode: {
    name: "Item Code",
    width: 0.4,
  },
  qtyTotal: {
    name: "Qty",
    width: 0.3,
  },
};
